export default {"src":"/_next/static/media/menu_close_01.c010fcff.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};